<template>
    <div class="container">
        <div class="row pr-bg-white pr-shadow-sm mb-3">
            <div class="col-12">
                <div class="d-flex align-items-center justify-content-between pr--breadcrumb-container p-0">
                    <BaseBreadcrumbs />
                </div>
            </div>
        </div>
        <!--        <div v-if="dataIndex.data.titles.collective !== undefined" class="row mt-3 mb-3 rounded-sm-bottom pr-bg-white">-->
        <!--            <div class="col-12 pr-shadow-sm p-3 rounded-2">-->
        <!--                <h2>{{ dataIndex.data.titles.collective.title }}</h2>-->
        <!--                {{ dataIndex.data.titles.collective.description }}-->
        <!--            </div>-->
        <!--        </div>-->
        <FrontendArticleCardList v-if="role === 'articles'" :store="feed" :on-change-page="onPageChange" />
        <div v-if="role === 'page'" class="row">
            <div class="col-12">
                <div v-if="pagesShow.pending" class="row">
                    <div class="pr--preloader __animated">
                        <div class="--icon" />
                        <div class="--text">
                            Идет загрузка ...
                        </div>
                    </div>
                </div>
                <div v-if="!pagesShow.pending" class="row">
                    <div class="col-12">
                        <FrontendPageDetails :item="pagesShow.data" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useTitle } from '@vueuse/core';
import { useAsyncData } from 'nuxt/app';
import { defineComponent, watch, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import BaseBreadcrumbs from '@/components/Base/Breadcrumbs/BaseBreadcrumbs.vue';
import FrontendArticleCardList from '@/components/Frontend/Article/FrontendArticleCardList.vue';
import FrontendPageDetails from '@/components/Frontend/Page/FrontendPageDetails.vue';
import { Breadcrumbs } from '@/hooks/Breadcrumbs';
import useSeo from '@/hooks/useSeo';
import { useStoreAppBreadcrumbsIndex } from '@/stores/app/breadcrumbs';
import { useStoreAppDataIndex } from '@/stores/app/data';
import { useStoreFeedIndex } from '@/stores/feed';
import { useStorePagesShow } from '@/stores/pages/show';
import { useStoreSystem } from '@/stores/system';
import { definePageMeta } from '#imports';

const route = useRoute();
const router = useRouter();
const system = useStoreSystem();
const breadcrumbs = (new Breadcrumbs());
// useTitle('Frontend Главная');
const dataIndex = useStoreAppDataIndex();
const feed = useStoreFeedIndex();
const pagesShow = useStorePagesShow();
const role = ref(pagesShow.loaded ? 'page' : 'articles');

async function fetchData(route, params) {
    if (process.client) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
    let data = {};

    data = Object.assign({}, data, route.query);

    breadcrumbs.init();

    const item = dataIndex.data.pages.groups.find(x => x.slug === route.params.slug);
    if (item !== undefined) {
        console.log('groups', item);
        data.group_id = item.id;
        breadcrumbs.pushGroup(item);
        useHead(useSeo().group(item));
        role.value = 'articles';
    }

    const item2 = dataIndex.data.pages.group_categories.find(x => x.slug === route.params.slug + '/' + route.params.slug2);
    if (item2 !== undefined) {
        console.log('group_categories', item2);
        data.group_category_id = item2.id;
        breadcrumbs.pushGroupCategory(item, item2);
        useHead(useSeo().groupCategory(item2, item));
        role.value = 'articles';
    }

    if (params !== undefined) {
        if (params.page !== undefined) {
            data.page = params.page;
        }
    }

    const item1 = dataIndex.data.pages.pages.find(x => x.slug === route.params.slug + '/' + route.params.slug2);
    if (item1 !== undefined) {
        data.page_id = item1.id;
        breadcrumbs.pushPage(item1);
        useHead(useSeo().page(item1));
        if (item1.type !== 'feed') {
            role.value = 'page';
        } else {
            data.type = item1.slug;
        }
    }

    breadcrumbs.create();
    console.log(data, role.value);
    if (role.value === 'articles') {
        await feed.fetch(data, (data) => {
            // useSeoMeta({
            //     title: '1',
            // });
        });
    }
    if (role.value === 'page') {
        data.id = data.page_id;
        delete data.page_id;
        await pagesShow.fetchShow(data, (data) => {
            // useSeoMeta({
            //     title: data.title,
            //     ogTitle: data.title,
            // });
        });
    }
}

if ((!feed.loaded && !pagesShow.loaded) || system.route.changed) {
    await useAsyncData('feed', async () => await fetchData(route, {}));
}
console.log('pages.[slug].[slug].index');
async function onPageChange(page) {
    await router.push({
        query: {
            page,
        },
    });
    await fetchData(route, {
        page,
    });
}
definePageMeta({
    middleware: [
        'data',
    ],
});
</script>
